export class TblCommunicationSetup
{
    refNo: number;
    communicationName: string;
    api: string;
    userId: string;
    password: string;
    token: string;
    port: string;
}